import React from 'react';
import UserTable from '../../components/molecules/users/table';

const Users: React.FC = () => (<UserTable />);

export default Users;
